import debug from "debug"

export default debug(process.env.REPLACE_PKG_NAME)